import { EntityState, Update } from '@ngrx/entity';

import { Favourite } from '@shared/models/favourite';
import { PreferencesAction, PreferencesActionTypes } from '../actions';
import { favouriteAdapter } from '../adapters';

export interface FavouritesState extends EntityState<Favourite> {
  loading: boolean;
  nextPage: boolean;
}

export const initialFavouritesState: FavouritesState = favouriteAdapter.getInitialState({
  loading: true,
  nextPage: false,
});

export function favouritesReducer(
  state: FavouritesState = initialFavouritesState,
  action: PreferencesAction
): FavouritesState {
  switch (action.type) {
    case PreferencesActionTypes.LOAD_FAVOURITES: {
      return {
        ...initialFavouritesState,
      };
    }

    case PreferencesActionTypes.LOAD_FAVOURITES_NEXT_PAGE: {
      return {
        ...state,
        loading: true,
      };
    }

    case PreferencesActionTypes.LOAD_FAVOURITES_SUCCESS: {
      const newFavouritesState: FavouritesState = {
        ...state,
        loading: false,
        nextPage: action.nextPage,
      };

      return favouriteAdapter.addMany(action.favourites, newFavouritesState);
    }

    case PreferencesActionTypes.TOGGLE_PREFERENCE: {
      const update: Update<Favourite> = {
        id: action.id,
        changes: {
          preferred: !state.entities[action.id]?.preferred,
        },
      };

      return favouriteAdapter.updateOne(update, { ...state });
    }

    default:
      return state;
  }
}
